import { useTranslation } from 'react-i18next'
import { MoonIcon } from './icons/MoonIcon'
import { SunIcon } from './icons/SunIcon'
import { useTheme } from '../hooks/useTheme'

/**
 * Theme toggle icon button. Shared between the authenticated header (TopBar)
 * and the unauthenticated Login screen so both surfaces use the same
 * underlying theme state/hook and icon-button treatment.
 */
export function ThemeToggleButton() {
  const { t } = useTranslation()
  const { theme, toggleTheme } = useTheme()

  return (
    <button
      type="button"
      className="top-bar-icon-btn"
      aria-label={t('topBar.toggleTheme')}
      title={t('topBar.toggleTheme')}
      onClick={toggleTheme}
    >
      {theme === 'light' ? <MoonIcon /> : <SunIcon />}
    </button>
  )
}
